/** WMO → overlay. Bez I/O, ať to jde testovat i z Deno. */
export type AcmWeather = 'off' | 'rain' | 'snow' | 'sun' | 'storm' | 'fog';
export type WeatherMode = 'manual' | 'auto';

export const WEATHERS: readonly AcmWeather[] = [
  'off',
  'rain',
  'snow',
  'sun',
  'storm',
  'fog',
] as const;

export const WEATHER_META: Record<
  AcmWeather,
  { label: string; hint: string }
> = {
  off: { label: 'Vypnuto', hint: 'Bez filtru' },
  rain: { label: 'Déšť', hint: 'Jemné kapky přes UI' },
  snow: { label: 'Sníh', hint: 'Padající vločky' },
  sun: { label: 'Slunce', hint: 'Teplé paprsky z rohu' },
  storm: { label: 'Bouřka', hint: 'Déšť, vítr a blesk' },
  fog: { label: 'Mlha', hint: 'Hustá opona přes plochy' },
};

/** Základ UI: overlay vypnutý. Legacy auto bylo implicitní, ne volba. */
export function baselineWeatherMode(
  v2: string | null,
  legacy: string | null,
): { mode: WeatherMode; resetOverlay: boolean } {
  if (v2 === 'auto' || v2 === 'manual') return { mode: v2, resetOverlay: false };
  if (legacy === 'manual') return { mode: 'manual', resetOverlay: false };
  return { mode: 'manual', resetOverlay: true };
}

export function isAcmWeather(v: unknown): v is AcmWeather {
  return (
    v === 'off' ||
    v === 'rain' ||
    v === 'snow' ||
    v === 'sun' ||
    v === 'storm' ||
    v === 'fog'
  );
}

/**
 * WMO weather_code (Open-Meteo) → overlay.
 * Zataženo / noc bez srážek = off (slunce v noci by lhala).
 */
export function weatherFromWmo(code: number, isDay = true): AcmWeather {
  if (!Number.isFinite(code)) return 'off';
  const n = Math.trunc(code);
  if (n === 45 || n === 48) return 'fog';
  if (n >= 95) return 'storm';
  if ((n >= 71 && n <= 77) || n === 85 || n === 86) return 'snow';
  if ((n >= 51 && n <= 67) || (n >= 80 && n <= 82)) return 'rain';
  if (n <= 2 && isDay) return 'sun';
  return 'off';
}
